export const getPortalContainer = (selector: string) => {
	return document.querySelector<HTMLDivElement>(selector);
};
